import React from "react";

const TechnologiesIntro = () => {
    return (
        <>
            <section
                style={{
                    position: "relative",
                    overflow: "hidden",
                    background:
                        "linear-gradient(180deg,#fff 0%,#fff8f8 50%,#fff 100%)",
                    padding: "130px 24px 110px",
                }}
            >
                {/* Background Glow */}
                <div
                    style={{
                        position: "absolute",
                        width: "500px",
                        height: "500px",
                        background:
                            "radial-gradient(circle, rgba(232,33,42,.12), transparent 70%)",
                        top: "-180px",
                        right: "-120px",
                        borderRadius: "50%",
                        animation: "pulseGlow 8s ease-in-out infinite",
                    }}
                />

                <div
                    style={{
                        maxWidth: "1350px",
                        margin: "0 auto",
                        display: "grid",
                        gridTemplateColumns: window.innerWidth < 768 ? "1fr" : "1.1fr .9fr",
                        gap: window.innerWidth < 768 ? "40px" : "80px",
                        alignItems: "center",
                        position: "relative",
                        zIndex: 2,
                        padding: window.innerWidth < 768 ? "0 16px" : "0",
                    }}
                    className="tech-intro-wrap"
                >
                    {/* Left Content */}
                    <div>
                        <div
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "10px",
                                background: "rgba(232,33,42,.08)",
                                border: "1px solid rgba(232,33,42,.12)",
                                padding: "10px 18px",
                                borderRadius: "999px",
                                marginBottom: "28px",
                                animation: "fadeSlideUp .7s both",
                            }}
                        >
                            <span
                                style={{
                                    width: "8px",
                                    height: "8px",
                                    background: "#E8212A",
                                    borderRadius: "50%",
                                    animation: "pulseDot 2s infinite",
                                }}
                            />

                            <span
                                style={{
                                    fontSize: "12px",
                                    fontWeight: 700,
                                    letterSpacing: "2px",
                                    textTransform: "uppercase",
                                    color: "#E8212A",
                                    fontFamily:
                                        "'Plus Jakarta Sans',sans-serif",
                                }}
                            >
                                Modern App Technologies
                            </span>
                        </div>

                        <h1
                            style={{
                                fontFamily: "'Syne',sans-serif",
                                fontSize: "72px",
                                lineHeight: 1,
                                fontWeight: 800,
                                color: "#111",
                                marginBottom: "30px",
                                letterSpacing: "-3px",
                                animation: "fadeSlideUp .8s .1s both",
                            }}
                        >
                            Future-Ready
                            <br />
                            <span
                                style={{
                                    background:
                                        "linear-gradient(135deg,#E8212A,#ff5f66)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                }}
                            >
                                Technologies
                            </span>
                        </h1>

                        <p
                            style={{
                                fontSize: "18px",
                                lineHeight: "34px",
                                color: "#666",
                                maxWidth: "650px",
                                marginBottom: "42px",
                                fontFamily:
                                    "'Plus Jakarta Sans',sans-serif",
                                animation: "fadeSlideUp .9s .2s both",
                            }}
                        >
                            At AppVerseLabs, we leverage cutting-edge mobile and
                            web technologies to craft lightning-fast, scalable,
                            and visually immersive digital products. From native
                            iOS & Android apps to AI-powered cross-platform
                            solutions — our tech stack is built for the future.
                        </p>

                        {/* Stats */}
                        <div
                            style={{
                                display: "flex",
                                gap: "22px",
                                flexWrap: "wrap",
                                animation: "fadeSlideUp 1s .3s both",
                            }}
                        >
                            {[
                                {
                                    title: "30+",
                                    desc: "Technologies Used",
                                },
                                {
                                    title: "100%",
                                    desc: "Scalable Architecture",
                                },
                                {
                                    title: "24/7",
                                    desc: "Performance Monitoring",
                                },
                            ].map((item, i) => (
                                <div
                                    key={i}
                                    style={{
                                        background: "#fff",
                                        border: "1px solid #f2f2f2",
                                        borderRadius: "24px",
                                        padding: "24px 28px",
                                        minWidth: "180px",
                                        boxShadow:
                                            "0 10px 40px rgba(0,0,0,.04)",
                                        transition: "all .35s ease",
                                        cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform =
                                            "translateY(-8px)";
                                        e.currentTarget.style.boxShadow =
                                            "0 20px 50px rgba(232,33,42,.12)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform =
                                            "translateY(0px)";
                                        e.currentTarget.style.boxShadow =
                                            "0 10px 40px rgba(0,0,0,.04)";
                                    }}
                                >
                                    <h3
                                        style={{
                                            fontSize: "38px",
                                            marginBottom: "10px",
                                            fontWeight: 800,
                                            color: "#111",
                                            fontFamily: "'Syne',sans-serif",
                                        }}
                                    >
                                        {item.title}
                                    </h3>

                                    <p
                                        style={{
                                            fontSize: "14px",
                                            color: "#777",
                                            lineHeight: "24px",
                                            fontFamily:
                                                "'Plus Jakarta Sans',sans-serif",
                                        }}
                                    >
                                        {item.desc}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Side */}
                    <div
                        style={{
                            position: "relative",
                            height: "620px",
                            animation: "fadeSlideLeft 1s .4s both",
                        }}
                    >
                        {/* Main Circle */}
                        <div
                            style={{
                                position: "absolute",
                                inset: "50%",
                                transform: "translate(-50%,-50%)",

                                borderRadius: "50%",
                                background:
                                    "linear-gradient(135deg,#fff,#fff5f5)",
                                border: "1px solid #f2dede",
                                boxShadow:
                                    "0 40px 120px rgba(232,33,42,.12)",
                                animation: "rotateSlow 18s linear infinite",
                            }}
                        />

                        {/* Center Logo */}
                        <div
                            style={{
                                position: "absolute",
                                left: "34%",
                                top: "37%",
                                transform: "translate(-50%,-50%)",
                                width: "150px",
                                height: "150px",
                                borderRadius: "40px",
                                background:
                                    "linear-gradient(135deg,#E8212A,#ff6268)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                fontSize: "50px",
                                fontWeight: 800,
                                fontFamily: "'Syne',sans-serif",
                                boxShadow:
                                    "0 30px 80px rgba(232,33,42,.35)",
                                animation: "floatBox 5s ease-in-out infinite",
                            }}
                        >
                            AV
                        </div>

                        {/* Floating Tech Cards */}
                        {[
                            {
                                name: "React Native",
                                top: "11%",
                                left: "35%",
                            },
                            {
                                name: "Flutter",
                                top: "33%",
                                right: "0%",
                            },
                            {
                                name: "Swift",
                                bottom: "33%",
                                right: "5%",
                            },
                            {
                                name: "Kotlin",
                                bottom: "11%",
                                left: "43%",
                            },
                            {
                                name: "Firebase",
                                bottom: "33%",
                                left: "0%",
                            },
                            {
                                name: "Node.js",
                                top: "33%",
                                left: "0%",
                            },
                        ].map((tech, i) => (
                            <div
                                key={i}
                                style={{
                                    position: "absolute",
                                    ...tech,
                                    transform:
                                        tech.left === "50%"
                                            ? "translateX(-50%)"
                                            : "",
                                    background: "#fff",
                                    border: "1px solid #f2f2f2",
                                    borderRadius: "18px",
                                    padding: "16px 20px",
                                    boxShadow:
                                        "0 15px 40px rgba(0,0,0,.06)",
                                    animation: `floatTech ${4 + i
                                        }s ease-in-out infinite`,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 700,
                                        color: "#111",
                                        fontFamily:
                                            "'Plus Jakarta Sans',sans-serif",
                                    }}
                                >
                                    {tech.name}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* CSS */}
                <style>{`

                @keyframes fadeSlideUp{
                    from{
                        opacity:0;
                        transform:translateY(40px);
                    }
                    to{
                        opacity:1;
                        transform:translateY(0);
                    }
                }

                @keyframes fadeSlideLeft{
                    from{
                        opacity:0;
                        transform:translateX(60px);
                    }
                    to{
                        opacity:1;
                        transform:translateX(0);
                    }
                }

                @keyframes rotateSlow{
                    from{
                        transform:translate(-50%,-50%) rotate(0deg);
                    }
                    to{
                        transform:translate(-50%,-50%) rotate(360deg);
                    }
                }

                @keyframes floatBox{
                    0%,100%{
                        transform:translate(-50%,-50%) translateY(0px);
                    }
                    50%{
                        transform:translate(-50%,-50%) translateY(-16px);
                    }
                }

                @keyframes floatTech{
                    0%,100%{
                        transform:translateY(0px);
                    }
                    50%{
                        transform:translateY(-14px);
                    }
                }

                @keyframes pulseGlow{
                    0%,100%{
                        transform:scale(1);
                    }
                    50%{
                        transform:scale(1.1);
                    }
                }

                @keyframes pulseDot{
                    0%,100%{
                        transform:scale(1);
                        opacity:1;
                    }
                    50%{
                        transform:scale(1.4);
                        opacity:.6;
                    }
                }

                @media(max-width:1100px){

                    .tech-intro-wrap{
                        grid-template-columns:1fr !important;
                        gap:80px !important;
                    }

                }

                @media(max-width:768px){

                    section{
                        padding:100px 20px 80px !important;
                    }

                    h1{
                        font-size:48px !important;
                        line-height:1.1 !important;
                    }

                }

                @media(max-width:600px){

                    h1{
                        font-size:40px !important;
                    }

                    .tech-intro-wrap{
                        gap:60px !important;
                    }

                }
/* ================= MOBILE RESPONSIVE ================= */

@media(max-width:1100px){

    .tech-intro-wrap{
        grid-template-columns:1fr !important;
        gap:80px !important;
    }

}

/* Tablet */

@media(max-width:768px){

    section{
        padding:90px 18px 70px !important;
    }

    h1{
        font-size:52px !important;
        line-height:1.08 !important;
        letter-spacing:-2px !important;
    }

    p{
        font-size:16px !important;
        line-height:30px !important;
    }

    .tech-intro-wrap{
        gap:70px !important;
    }

}

/* Mobile */

@media(max-width:600px){

    section{
        padding:80px 16px 60px !important;
    }

    .tech-intro-wrap{
        gap:55px !important;
                display: inline !important;
    }

    h1{
        font-size:30px !important;
        line-height:1.12 !important;
        letter-spacing:-1.5px !important;
        margin-bottom:22px !important;
    }

    /* Stats cards */

    .tech-intro-wrap > div:first-child > div:last-child{
        display:grid !important;
        grid-template-columns:1fr !important;
        gap:16px !important;
    }

    .tech-intro-wrap > div:first-child > div:last-child > div{
        width:100% !important;
        min-width:100% !important;
        padding:22px 20px !important;
        border-radius:22px !important;
    }

    .tech-intro-wrap > div:first-child > div:last-child h3{
        font-size:30px !important;
    }

    /* Right Animation Area */

    .tech-intro-wrap > div:last-child{
        height:420px !important;
    }

    /* Main Circle */

    .tech-intro-wrap > div:last-child > div:first-child{
        width:260px !important;
        height:260px !important;
    }

    /* Center Logo */

    .tech-intro-wrap > div:last-child > div:nth-child(2){
        width:95px !important;
        height:95px !important;
        border-radius:26px !important;
        font-size:34px !important;
                left: 38% !important;
    }

    /* Floating Tech Cards */

    .tech-intro-wrap > div:last-child > div:not(:first-child):not(:nth-child(2)){
        padding:10px 14px !important;
        border-radius:14px !important;
    }

    .tech-intro-wrap > div:last-child span{
        font-size:12px !important;
    }

    /* Tech Positions */

    .tech-intro-wrap > div:last-child > div:nth-child(3){
                left: 50% !important;
        transform:translateX(-50%) !important;
    }

    .tech-intro-wrap > div:last-child > div:nth-child(4){
      
               right: 48px !important;
    }

    .tech-intro-wrap > div:last-child > div:nth-child(5){
        bottom:26% !important;
        right:48px !important;
    }

    .tech-intro-wrap > div:last-child > div:nth-child(6){
     
        left:50% !important;
        transform:translateX(-50%) !important;
    }

    .tech-intro-wrap > div:last-child > div:nth-child(7){
        bottom:26% !important;
        left:48px !important;
    }

    .tech-intro-wrap > div:last-child > div:nth-child(8){
             left: 48px !important;
    }

}
    
            `}</style>
            </section>
        </>
    );
};

export default TechnologiesIntro;